var nativeFocus = (theme, disabled) => {
  var isHC = theme.mode === 'contrast';
  if (disabled) return {
    ':focus': {
      outline: 'none'
    }
  };
  return {
    outline: '2px solid transparent',
    outlineOffset: '2px',
    ':focus-visible': {
      outlineColor: isHC ? theme.palette.primary.active : theme.palette.primary.default
    }
  };
};
export default nativeFocus;